import React, { useEffect, useState } from "react";
import fastFood from "../../assets/newLogo.jpeg";
import person from "../../assets/random_pp.png";
import { Link } from "react-router-dom";
import moment from "moment";
import styles from "./TrackDelivery.module.css";
import { useDispatch, useSelector } from "react-redux";
import { getOrderById, getDirection } from "../../redux/actions/orderActions";
import Map from './../../components/MapDirection/index';
import { withScriptjs } from "react-google-maps";


const TrackDelivery = (props) => {
  const { match } = props;
  const getOrder = useSelector((state) => state.getOrderById);
  const { loading, order: details, error } = getOrder;

  const { direction } = useSelector((state) => state.getDirectionReducer);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getOrderById(match.params.id));
  }, [dispatch]);

  const mapStyles = {
    width: "100%",
    height: "100%",
  };

  const order = details && details;

  useEffect(() => {
    dispatch(
      getDirection(
        order && order.pickup.address.address,
        order && order.dropoff.address.address
      )
    );
  }, [dispatch, order]);

  const triangleCoords = [
    {
      lat: Number(order?.pickup.address.coordinates.lat),
      lng: Number(order?.pickup.address.coordinates.long),
    },
    {
      lat: Number(order?.dropoff.address.coordinates.lat),
      lng: Number(order?.dropoff.address.coordinates.long),
    },
  ];

  const e = direction?.routes[0].overview_polyline.points;
  const MapLoader = withScriptjs(() => <Map coordinates={{
    pick: {
      lat: order.pickup.address.coordinates.lat,
      lng: order.pickup.address.coordinates.long
    },
    drop: {
      lat: order.dropoff.address.coordinates.lat,
      lng: order.dropoff.address.coordinates.long,
    }
  }} />);


  return (
    <div className={styles.container}>
      <div className={styles.box}></div>

      {loading && <h2>Loading...</h2>}
      {error && <h2>{error}</h2>}

      {order && (
        <div>
          <header>
            <div className={styles.topHeader}>
              <Link to="/my-deliveries">
                <i className={styles.backIcon + " fas fa-chevron-left"}></i>
              </Link>
              <h3>Order ID {order._id}</h3>
            </div>
            <div className={styles.bottomHeader}>
              <div className={styles.top}>
                <img src={fastFood} alt="fast-food" />
                <div className={styles.name}>
                  <h3>{order.typeOfOrder}</h3>
                  <small>
                    {moment(order.date).format("DD MMM YYYY, hh:mm a")}
                  </small>
                </div>
                <div className={styles.deliveryStatus}>
                  <h4>Picking in {order.pickMinutes} Min</h4>
                  <small>$ {order.payment_amount}</small>
                </div>
              </div>
            </div>
          </header>

          <main>
            <div className={styles.mapsContainer}>
              <MapLoader
                googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyBs18XKLLip0CBo__x3a33ADc5N1VA1mfE"
                loadingElement={<div style={{ height: `100%` }}
                />}
              />
            </div>

            <div className={styles.content}>
              <div className={styles.dialContainer}>
                <img src={person} alt="profile-pic" />
                <div className={styles.dialInfo}>
                  <h2>John Doe</h2>
                  <small>some career</small>
                </div>
                <a href="tel:+393427056246">
                  <i className="fas fa-phone"></i>
                </a>
              </div>
              <div className={styles.directionsContainer}>
                <div className={styles.iconsContainer}>
                  <i className={styles.icon + " fas fa-map-marker-alt"}></i>
                  <span className={styles.line}></span>
                  <i className={styles.icon + " fas fa-location-arrow"}></i>
                </div>
                <div className={styles.places}>
                  <div className={styles.place}>
                    <small>{order.pickup.landmark}</small>
                    <h2>{order.pickup.personName}</h2>
                    <p>{order.pickup.address.address}</p>
                  </div>
                  <div className={styles.place}>
                    <small>{order.dropoff.landmark}</small>
                    <h2>{order.dropoff.personName}</h2>
                    <p>{order.dropoff.address.address}</p>
                  </div>
                </div>
              </div>

              <div className={styles.infoContainer}>
                <div className={styles.box_2}>
                  <small>Courier Type</small>
                  <p>{order.courierInfo.typeOfCourier}</p>
                </div>
                <div className={styles.box_2}>
                  <small>Frangible</small>
                  <p>{order.courierInfo.IsFragile ? <p>Yes</p> : <p>No</p>}</p>
                </div>
                <div className={styles.box_2}>
                  <small>Height Widht Length</small>
                  <p>{order.courierInfo.lwh} (cm)</p>
                </div>
                <div className={styles.box_2}>
                  <small>Weight</small>
                  <p>{order.courierInfo.weight}</p>
                </div>
                <div className={styles.box_2}>
                  <small>Courier Info</small>
                  <p>{order.courierInfo.details}</p>
                </div>
              </div>

              <div className={styles.total}>
                <div className={styles.totalLeft}>
                  <h2>Total</h2>
                  <small>Payment via {order.payment}</small>
                </div>
                <div className={styles.totalRight}>
                  <h2>€ {order.payment_amount}</h2>
                </div>
              </div>
            </div>
          </main>
        </div>
      )}
    </div>
  );
};
export default TrackDelivery;
